import { render, staticRenderFns } from "./appVersionUpdate.vue?vue&type=template&id=816cd306&"
import script from "./appVersionUpdate.vue?vue&type=script&lang=js&"
export * from "./appVersionUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports